export default {
  apiKey: "AIzaSyDI6_hFA3tQEHxqDJjDfZb2u-l9gslaOqg",
  authDomain: "gms-dnacloud-p.firebaseapp.com",
  databaseURL: "https://gms-dnacloud-p-default-rtdb.firebaseio.com",
  projectId: "gms-dnacloud-p",
  storageBucket: "gms-dnacloud-p.appspot.com",
  messagingSenderId: "316737739398",
  appId: "1:316737739398:web:5f80144a3389c82cf04f07",
};